var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33332 15C9.81247 14.9997 11.249 14.5045 12.4142 13.5933L16.0775 17.2566L17.2558 16.0783L13.5925 12.415C14.5042 11.2497 14.9996 9.81282 15 8.33329C15 4.65746 12.0092 1.66663 8.33332 1.66663C4.65749 1.66663 1.66666 4.65746 1.66666 8.33329C1.66666 12.0091 4.65749 15 8.33332 15ZM8.33332 3.33329C11.0908 3.33329 13.3333 5.57579 13.3333 8.33329C13.3333 11.0908 11.0908 13.3333 8.33332 13.3333C5.57582 13.3333 3.33332 11.0908 3.33332 8.33329C3.33332 5.57579 5.57582 3.33329 8.33332 3.33329Z",
    fill: "#77787D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic-search.f165d42117379ec9063be84d69e6117a.svg";
export { ForwardRef as ReactComponent };